<template>
  <div
    class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
     :class="{'bg_detail': bg}">
    </div>
      <section
        class="size_detail
          zero_right
          margin_top_detail
          padding_bottom_detail
          has-background-white
          is-scrollable">
        <div class="columns is-marginless detail_content detail_content_bg">
          <div class="half_width detail_img_info">
            <img :src="url" class="imageBgOpp">
          </div>
          <div class="half_width topVert leftVert rightVert">
            <a @click="$parent.show = false"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size="">
              </b-icon>
            </a>
            <h3 class="has-text-weight-bold has-text-link bottomViolet">
              Proposition:</h3>
            <div class="columns is-marginless is-multiline color-icon detail_content_propo">
              <div class="column bottomViolet is-paddingless is-6"
                   v-if="detailResauxComplet.extensionOpportunite.quantite">
                <div class="media">
                  <b-icon
                    icon="timer"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Durée
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{formatDureeNum(detailResauxComplet.extensionOpportunite.typeTarification,
                        detailResauxComplet.extensionOpportunite.quantite)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="tarif"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      {{detailResauxComplet.extensionOpportunite.tarifNet ?
                      'Tarif Net HT' : 'Tarif HT'}}
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{formatNum(tarif)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.fraisAdserving"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="tooltip-plus"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Frais Adserving
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{fraisAdserving}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column bottomViolet is-paddingless is-6"
                   v-if="detailResauxComplet.extensionOpportunite.typeTarification">
                <div class="media">
                  <b-icon
                    icon="cellphone-screenshot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Mode de diffusion
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{modeDiff(detailResauxComplet.extensionOpportunite.typeTarification)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.nbDiffusion"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="counter"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Diffusion/jour
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.extensionOpportunite.nbDiffusion}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailResauxComplet.extensionOpportunite.spotsPub"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="camera-metering-spot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Spot(s) Publicitaire(s)
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.extensionOpportunite.spotsPub}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailResauxComplet.extensionOpportunite.commentaire">
              <h3 class="has-text-weight-bold topViolet has-text-link">
                Commentaire:</h3>
              <div class="">
                <p class="has-text-link has-text-justify p_size14 mb-btnaction">
                  {{detailResauxComplet.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-marginless is-block detail_content">
          <div class="column leftVert topViolet rightVert is-paddingless">
            <h3 class="has-text-weight-bold bottomVert has-text-link">
              Caractéristiques:</h3>
            <p class="is-size-7 bottomViolet">
              <label class="has-text-default">
                Nom du réseau
              </label><br>
              <strong class="p_size14 has-text-link">
                {{detailResauxComplet.libelle}}
              </strong>
            </p>
            <div class="columns is-multiline color-icon">
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="city"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Ville
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.ville}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Nombre de d'écrans
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailResauxComplet.nbFaces}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="detailResauxComplet.extensionOpportunite.periode" class="column color-icon">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Période
                </label><br>
                <p class="p_size14 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.extensionOpportunite.periode}}
                </p>
              </div>
            </div>
          </div>
          <div class="column topRouge bottomVert is-4 is-offset-8">
            <div v-if="!detailResauxComplet.select" @click="contolSelect()">
              <a class="button is-primary is-rounded rightVert">Ajouter à ma sélection</a>
            </div>
            <div v-else @click="contolSelect()">
              <a class="button boutonRed has-text-white is-rounded rightVert">
                Retirer de ma sélection</a>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { urlPhoto, formatNum, formatDate, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxNumeriqueCompletDiapo',
  props: ['detailResauxComplet', 'bg'],
  data() {
    return {
      show: false,
      hoverButton: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.detailResauxComplet.urlPhoto);
    },
    date() {
      return formatDate(this.detailResauxComplet.extensionOpportunite.date);
    },
    fraisAdserving() {
      return formatNum(this.detailResauxComplet.extensionOpportunite.fraisAdserving);
    },
    tarif() {
      if (this.detailResauxComplet.extensionOpportunite.tarifNet) {
        return this.detailResauxComplet.extensionOpportunite.tarifNet;
      }
      return this.detailResauxComplet.extensionOpportunite.tarifHt;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailResauxComplet.select = !this.detailResauxComplet.select;
      if (this.detailResauxComplet.select) {
        this.add(this.tarif);
        this.addNbSelect();
      } else {
        this.substract(this.tarif);
        this.substractNbSelect();
      }
    },
    formatNum(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxNumeriques/detailReseauxNumeriqueCompletDiapo.vue